import { render, staticRenderFns } from "./BillableItemDetails.vue?vue&type=template&id=ade3b3ca&scoped=true"
import script from "./BillableItemDetails.vue?vue&type=script&lang=js"
export * from "./BillableItemDetails.vue?vue&type=script&lang=js"
import style0 from "./BillableItemDetails.vue?vue&type=style&index=0&id=ade3b3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade3b3ca",
  null
  
)

export default component.exports